const Logo = () => {
    return (
        <span className='logo-emblem' />
    )
}

export { Logo }
